import { get, startCase } from "lodash"
import { fetchInstaproGames, fetchPgGames } from "./game.apis"
import { isGameFPS } from "./game.utils"
import LeagueOfLegends from "./leagueoflegends/leagueoflegends.module"
import SSBU from "./ssbu/ssbu.module"

const state = {
  pgGames: [],
  instaproGames: [],
}
const getters = {
  isGameFPS: () => gameKey => isGameFPS(gameKey),
  gameByKey: (state, getters) => key => {
    const game = getters.pgGamesMap[key]
    return game
  },
  gameNameByKey: (state, getters) => gameKey => {
    const game = getters.gameByKey(gameKey)
    return get(game, "name", startCase(gameKey))
  },
  gameIconByKey: (state, getters) => gameKey => {
    const game = getters.gameByKey(gameKey)
    return get(game, ["images", "icon"])
  },
  gameBannerByKey: (state, getters) => gameKey => {
    const game = getters.gameByKey(gameKey)
    return get(game, ["images", "banner"])
  },
  gamePortraitByKey: (state, getters) => gameKey => {
    const game = getters.gameByKey(gameKey)
    return get(game, ["images", "portrait"])
  },
  gameSquareByKey: (state, getters) => gameKey => {
    const game = getters.gameByKey(gameKey)
    return get(game, ["images", "square"])
  },
  pgGames: state => state.pgGames,
  pgGamesMap: state =>
    state.pgGames.reduce(
      (result, game) => ({ ...result, [game.key]: game }),
      {}
    ),
  instaproGames: state => state.instaproGames,
  availableInstaproGames: state =>
    state.instaproGames.filter(game => game.available),
  availableInstaproGamesMap: (state, getters) =>
    getters.availableInstaproGames.reduce(
      (result, game) => ({ ...result, [game.name]: game }),
      {}
    ),
  pgGamesAvailableForInstapro: (state, getters) => {
    // console.log(getters.availableInstaproGames)
    return state.pgGames.filter(
      game => getters.availableInstaproGamesMap[game.key]
    )
  },
}
const mutations = {
  setPgGames: (state, games) => (state.pgGames = games),
  setInstaproGames: (state, games) => (state.instaproGames = games),
}
const actions = {
  async fetchPgGames ({ state, commit }) {
    if (state.pgGames.length) return
    const games = await fetchPgGames()
    if (Array.isArray(games)) {
      commit("setPgGames", games)
    }
  },
  async fetchInstaproGames ({ state, commit }) {
    if (state.instaproGames.length) return
    const games = await fetchInstaproGames()
    if (Array.isArray(games)) {
      commit("setInstaproGames", games)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    LeagueOfLegends,
    SSBU,
  },
}



// WEBPACK FOOTER //
// ./src/store/game/game.module.js